
/* styles */
require("!!../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../vue-loader/lib/style-rewriter?id=data-v-297a9ac5&scoped=true!../../../vue-loader/lib/selector?type=styles&index=0!./Popover.vue")

var Component = require("!../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../vue-loader/lib/selector?type=script&index=0!./Popover.vue"),
  /* template */
  null,
  /* scopeId */
  "data-v-297a9ac5",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/v-calendar/src/components/Popover.vue
// module id = 304
// module chunks = 94